module.exports = __webpack_public_path__ + "static/media/google_icon.32e6a212.png";